import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { InfoRounded } from "@mui/icons-material";

export function InfoFlag({ text }) {
    if (!text) {
        return null;
    }

    const tooltip = (
        <Popover id="popover">
            <Popover.Content>{text}</Popover.Content>
        </Popover>
    );
    return (
        <OverlayTrigger overlay={tooltip} placement="right" delayShow={300} delayHide={150}>
            <Flag color="primary" aria-hidden="true" />
        </OverlayTrigger>
    );
}

export const Flag = styled(InfoRounded)`
    && {
        margin-left: 4px;
        font-size: 1rem;
    }
`;

export const PopoverInnards = styled.div`
    font-size: 0.9em;
`;

InfoFlag.propTypes = {
    text: PropTypes.string
};
